import React from "react";

const GithubIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99968 0.333008C3.31634 0.333008 0.333009 3.31634 0.333009 6.99967C0.332253 8.39919 0.772218 9.76341 1.59049 10.8988C2.40875 12.0342 3.56377 12.8831 4.89168 13.325C5.22501 13.383 5.34968 13.183 5.34968 13.0077C5.34968 12.8497 5.34101 12.325 5.34101 11.7663C3.66634 12.075 3.23301 11.3583 3.09968 10.983C3.02434 10.791 2.69968 10.1997 2.41634 10.041C2.18301 9.91634 1.84968 9.60767 2.40768 9.59967C2.93301 9.59101 3.30768 10.083 3.43301 10.283C4.03301 11.291 4.99168 11.0077 5.37434 10.833C5.43301 10.3997 5.60768 10.1083 5.79968 9.94168C4.31634 9.77501 2.76634 9.19967 2.76634 6.64967C2.76634 5.92434 3.02434 5.32501 3.44968 4.85767C3.38301 4.69101 3.14968 4.00767 3.51634 3.09101C3.51634 3.09101 4.07434 2.91634 5.34968 3.77501C5.89238 3.62438 6.45312 3.54857 7.01634 3.54967C7.58301 3.54967 8.14968 3.62434 8.68301 3.77434C9.95768 2.90767 10.5163 3.09167 10.5163 3.09167C10.883 4.00834 10.6497 4.69167 10.583 4.85834C11.0077 5.32501 11.2663 5.91634 11.2663 6.64967C11.2663 9.20834 9.70834 9.77501 8.22501 9.94168C8.46634 10.1497 8.67501 10.5497 8.67501 11.175C8.67501 12.0663 8.66634 12.783 8.66634 13.0083C8.66634 13.183 8.79168 13.391 9.12501 13.3243C10.4484 12.8775 11.5983 12.027 12.4129 10.8924C13.2276 9.75788 13.666 8.39642 13.6663 6.99967C13.6663 3.31634 10.683 0.333008 6.99968 0.333008Z"
        fill="#B6B5BB"
      />
    </svg>
  );
};

export default GithubIcon;
